import { apiGet, apiPut, apiPost, apiDelete, apiUpload, API_ENDPOINTS } from "../utils/apiUtils";

const GamificationService = {
  async getBadges() {
    return apiGet(API_ENDPOINTS.GAMIFICATION.BADGES);
  },

  async reorderLevels(items) {
    return apiPost(API_ENDPOINTS.GAMIFICATION.LEVELS_REORDER, { items });
  },

  // Update badge (title, description, badge_url, etc.)
  async updateBadge(badgeId, payload) {
    return apiPut(`/api/v1/admin/gamification/badge/${badgeId}`, payload);
  },

  async deleteBadge(badgeId) {
    return apiDelete(`/api/v1/admin/gamification/badge/${badgeId}`);
  },

  async getAchievementBadges() {
    return apiGet(API_ENDPOINTS.GAMIFICATION.ACHIEVEMENT_BADGES);
  },

  async updateAchievementBadge(achievementBadgeId, payload) {
    return apiPut(`/api/v1/admin/gamification/achievement-badge/${achievementBadgeId}`, payload);
  },

  async deleteAchievementBadge(achievementBadgeId) {
    return apiDelete(`/api/v1/admin/gamification/achievement-badge/${achievementBadgeId}`);
  },

  async reorderAchievementBadges(items) {
    return apiPost(API_ENDPOINTS.GAMIFICATION.ACHIEVEMENT_BADGES_REORDER, { items });
  },

  async getFeatureUnlocks() {
    return apiGet(API_ENDPOINTS.GAMIFICATION.FEATURE_UNLOCKS);
  },

  async updateFeatureUnlock(configId, payload) {
    return apiPut(API_ENDPOINTS.GAMIFICATION.UPDATE_FEATURE_UNLOCK(configId), payload);
  },

  async deleteFeatureUnlock(configId) {
    return apiDelete(API_ENDPOINTS.GAMIFICATION.UPDATE_FEATURE_UNLOCK(configId));
  },

  async reorderFeatureUnlocks(items) {
    return apiPost(API_ENDPOINTS.GAMIFICATION.FEATURE_UNLOCKS_REORDER, { items });
  },

  async getDailyTasks() {
    return apiGet(API_ENDPOINTS.GAMIFICATION.DAILY_TASKS);
  },

  async getTodayUserTasks(params = {}) {
    return apiGet(API_ENDPOINTS.GAMIFICATION.TODAY_USER_TASKS, params);
  },

  async scheduleDailyTasks(payload) {
    return apiPost(API_ENDPOINTS.GAMIFICATION.DAILY_TASKS_SCHEDULE, payload);
  },

  async updateDailyTaskSchedule(payload) {
    return apiPut(API_ENDPOINTS.GAMIFICATION.DAILY_TASKS_SCHEDULE, payload);
  },

  async updateDailyTask(taskId, payload) {
    return apiPut(API_ENDPOINTS.GAMIFICATION.UPDATE_DAILY_TASK(taskId), payload);
  },

  async uploadDailyTasks(file) {
    const formData = new FormData();
    formData.append("file", file);
    return apiUpload(API_ENDPOINTS.GAMIFICATION.DAILY_TASKS_UPLOAD, formData);
  },
};

export default GamificationService;

